import request from '@/helpers/request'

export default {
  async index() {
    return await request.get('instructor')
  },
  async show(instructorId) {
    return await request.get('instructor/' + instructorId)
  }
}

